<template>
  <el-dialog
    title="通用唛头模板编辑唛头"
    :visible="isShow"
    custom-class="temp-style"
    width="80%"
    :before-close="handleClose"
    destroy-on-close
  >
    <el-main
      v-if="isLoading"
      v-loading="isLoading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    />
    <template v-else>
      <el-row>
        <h4>基础信息</h4>
        <el-form
          ref="formData"
          :inline="false"
          :model="formData"
        >
          <el-col
            v-for="(item, index) in baseMessageList"
            :key="index"
            :span="item.colSpan"
          >
            <el-form-item
              :label="`${item.fieldDisplayName}：`"
              :prop="item.fieldKey"
              label-width="110px"
              :rules="[
                {
                  required: item.attributeType === '输入框' && item.isRequired,
                  message: `${item.fieldDisplayName}不能为空`
                }
              ]"
            >
              <el-input
                v-if="item.attributeType === '输入框'"
                v-model="formData[item.fieldKey]"
                :type="item.fieldKey === 'remark' ? 'textarea' : 'input'"
                placeholder="请输入"
                maxlength="255"
                :show-word-limit="item.fieldKey === 'remark'"
                @input="e => formData[item.fieldKey] = handleInputRule (e)"
              />
              <p v-else>
                {{ formData[item.fieldKey] }}
              </p>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>

      <h4>客户信息</h4>
      <div class="client-container">
        <ul>
          <li v-for="(item, index) in clientInfo" :key="index" class="flex flex-align">
            <div class="client-item flex flex-align flex-1">
              <label>收货信息标题{{ index + 1 }}：</label>
              <el-input v-model="item.title" placeholder="请输入收货信息标题" maxlength="255" @input="e => item.title = handleInputRule (e)" />
            </div>
            <div class="last client-item flex flex-align flex-1">
              <label>收货信息内容{{ index + 1 }}：</label>
              <el-input v-model="item.content" placeholder="请输入收货信息内容" maxlength="255" @input="e => item.content = handleInputRule (e)" />
            </div>
            <div class="operate-style flex">
              <i class="iconfont el-icon-plus" @click="operate('add')" />
              <i v-show="clientInfo.length > 1" class="iconfont el-icon-minus" @click="operate('delete', index)" />
            </div>
          </li>
        </ul>
      </div>

      <div class="flex flex-align product-style">
        <h4>产品信息</h4>
        <el-button :disabled="!this.selectList.length" type="primary" class="btn-style" @click="handleCopy">
          复制头客户信息到勾选产品行上
        </el-button>
        <el-button :disabled="!this.selectList.length" type="primary" class="btn-style" @click="handleClear">
          清空勾选产品的客户信息
        </el-button>
      </div>

      <el-table
        ref="tableDataRef"
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="handleSelection"
      >
        <el-table-column
          type="selection"
          fixed
          width="55"
        />
        <el-table-column fixed label="序号" align="left" type="index" />
        <el-table-column
          v-for="(item, index) in productHeaderList"
          :key="index"
          :prop="item.fieldKey"
          :label="item.fieldDisplayName"
          align="left"
          :min-width="item.fieldKey === 'customerInfo' ? 200 : 150"
          :render-header="(h, obj) => renderHeader(h, obj, item)"
        >
          <template slot-scope="scope">
            <el-input
              v-if="item.attributeType === '输入框'"
              v-model="scope.row[item.fieldKey]"
              :type="setInputType(item)"
              placeholder="请输入"
              @input="e => scope.row[item.fieldKey] = handleInputRule (e)"
              @change="handelInputChange(item, scope, $event)"
            />
            <ul v-else-if="item.fieldKey === 'customerInfo'" class="customer-info-style">
              <li v-for="(cItem, cIndex) in scope.row[item.fieldKey]" :key="cIndex">
                {{ cItem.title }}： {{ cItem.content }}
              </li>
            </ul>
            <span v-else>
              {{ scope.row[item.fieldKey] }}
            </span>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { parseTime, handleInputRule } from '@/libs/util.js';
import { getMarkInfoData, markEditMark } from '@/API';
import handelChange from '@/views/returnExchange/Chief/commom/handelChange.vue';
export default {
  computed: {
    handelChange () {
      return handelChange;
    }
  },
  data () {
    return {
      isShow: false,
      paramsIds: {},
      markInfoNum: '', // 唛头id
      markTemplateId: '', // 模版id
      isLoading: false,
      formData: {},
      selectList: [],
      baseType: 'markField',
      baseMessageList: [], // 基础信息
      clientInfo: [{}], // 客户信息
      productHeaderList: [], // 产品信息Table头数据
      tableData: [], // 产品信息数据
      numberForm: ['productNum', 'sheetNum', 'totalSheetNum']
    };
  },

  methods: {
    handleInputRule,
    initData (params) {
      getMarkInfoData(params).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          // 基础信息的处理
          this.baseMessageList = (data.baseMessageList || []).map(item => {
            const val = () => {
              if (item.fieldKey === 'createTime') {
                return parseTime(new Date());
              } else if (item.fieldKey === 'createName') {
                return this.$store.state.user?.userName;
              }
              return item.defaultValue || '';
            };
            this.$set(this.formData, item.fieldKey, val());
            return {
              ...item,
              colSpan: ['remark'].indexOf(item.fieldKey) > -1 ? 24 : 8
            };
          });

          this.productHeaderList = (data.productHeaderList || []);
          this.tableData = (data.productValueList || []);
          this.markInfoNum = data.markInfoNum;
          this.markTemplateId = data.markTemplateId;
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.handleClose();
        }
      }).catch(e => {
        this.isLoading = false;
      });
    },

    // 表头增加必填*符号
    renderHeader (h, { column }, item) {
      if (!item.isRequired) return column.label;
      return [
        h('span', { style: 'color: #f56c6c' }, '*'),
        h('span', ' ' + column.label)
      ];
    },

    handelInputChange (item, scope, val) {
      let { row, $index } = scope;
      if (item.fieldDisplayName === '粘贴张数') {
        // 计算打印总张数
        let totalSheetNum = Number(val) * Number(row.markPackingNum);
        this.$set(this.tableData[$index], 'totalSheetNum', totalSheetNum);
      }
    },

    // 提交
    handleSubmit () {
      console.log(this.paramsIds, 'this.paramsIds');
      let state = [];
      let baseForm = {};
      let productInfoList = [];
      // 产品信息的必填数据有哪些
      let productRequired = [];
      // 产品信息的必填状态
      let productRequiredStatus = [];

      // 基础信息的数据处理
      this.baseMessageList.forEach(item => {
        Object.keys(this.formData).forEach(j => {
          if (j === item.fieldKey) {
            baseForm[`${this.baseType}${item.fieldOrder}`] = this.formData[j];
          }
        });
        if (item.attributeType === '输入框') {
          state.push(baseForm[this.baseType + item.fieldOrder]);
        }
      });

      // 产品信息的数据处理
      this.productHeaderList.forEach(item => {
        if (item.isRequired) {
          productRequired.push(`${item.fieldKey}`);
        }
        this.tableData.map(val => {
          Object.keys(val).forEach(key => {
            if (item.fieldKey === key) {
              val[`markProductField${item.fieldOrder}`] = val[key];
            }
          });
        });
      });

      // productInfoList 处理接口需要的数据格式
      productInfoList = this.tableData.map(val => {
        productRequired.forEach(item => {
          val[item] ? productRequiredStatus.push(1) : productRequiredStatus.push(0);
        });

        let obj = {};
        Object.keys(val).forEach(key => {
          if (key.includes('markProductField')) {
            obj[key] = val[key];
            obj.id = val.id;
          }
        });
        // 产品行需要补充的key集合
        let addKeyList = ['itemIndex', 'plmMarkBoxTotal', 'lastBoxTotal'];
        addKeyList.forEach(key => {
          obj[key] = val[key];
        });
        return obj;
      });

      console.log(productInfoList, 'productInfoList');

      const params = {
        markInfoNum: this.markInfoNum, // 唛头单据编号
        markTemplateId: this.markTemplateId, // 唛头模版Id
        markInfoId: this.paramsIds.markInfoId, // 唛头id
        partialId: this.paramsIds.partialId, // 发货列表id
        baseInformation: {
          ...baseForm,
          markInformationId: null
        },
        productInformation: productInfoList.map(i => {
          delete i.id;
          return {
            ...i,
            markProductField10: (i.markProductField10 || []).reduce((cur, prex, curI) => {
              return cur + `${prex.title}：${prex.content}${(curI === i.markProductField10.length - 1) ? '' : '<br/>'}`;
            }, '')
          };
        })
      };
      if (!state.every(item => item)) return this.$message.error('请输入必填项');
      if (!productRequiredStatus.every(item => item)) return this.$message.error('产品信息必填项请输入完成');

      markEditMark(params).then(res => {
        const { status } = res.data;
        if (status === '200') {
          this.$emit('set-data');
          this.handleClose();
          this.$message.success('提交成功');
        }
      });
    },

    // 客户信息操作
    operate (type, index) {
      if (type === 'add') {
        this.clientInfo.push({});
      } else if (type === 'delete') {
        this.clientInfo.splice(index, 1);
      }
    },

    handleCopy () {
      if (!this.selectList.length) return this.$message.error('请选择一项产品信息！');
      const tempAry = this.clientInfo.filter(i => i.title || i.content);
      if (!tempAry.every(i => i.title && i.content)) return this.$message.error('客户信息为必填项，请输入！');
      console.log(tempAry, 'tempAry');
      console.log(this.tableData, 'this.tableData');
      this.tableData.forEach(item => {
        if (this.selectList.indexOf(item.id) > -1) {
          // 客户信息赋值
          this.$set(item, 'customerInfo', JSON.parse(JSON.stringify([...tempAry, ...item.customerInfo])));
        }
      });
      this.$refs.tableDataRef.clearSelection();
    },

    handleClear () {
      if (!this.selectList.length) return this.$message.error('请选择一项产品信息！');
      this.tableData.forEach(item => {
        if (this.selectList.indexOf(item.id) > -1) {
          item.customerInfo = [];
        }
      });
      this.$refs.tableDataRef.clearSelection();
    },

    handleSelection (val) {
      this.selectList = val.map(i => i.id);
    },

    setInputType (item) {
      return this.numberForm.indexOf(item.fieldKey) > -1 ? 'number' : 'text';
    },

    openDialog (params) {
      this.paramsIds = params;
      this.isShow = true;
      this.isLoading = true;
      this.initData(params);
    },

    handleClose () {
      this.isShow = false;
      this.baseMessageList = [];
      this.clientInfo = [{}];
      this.productHeaderList = [];
      this.tableData = [];
    }
  }
};
</script>

<style lang="scss">
  .temp-style {
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    .el-dialog__body {
      padding: 20px !important;
      min-height: 300px !important;
    }
    .el-main {
      min-height: 300px !important;
    }
  }
</style>

<style lang="scss" scoped>
  .temp-style {
    .flex {
      display: flex;
    }
    .flex-align {
      align-items: center;
    }
    .flex-1 {
      flex: 1;
    }
    .el-col {
      min-height: 40px;
    }
    h4 {
      margin: 10px 0;
    }
    .product-style {
      margin: 12px 0;
      .btn-style {
        margin-left: 20px;
      }
    }
    .client-container {
    >ul {
      list-style: none;
      li {
        padding-bottom: 12px;
        .last {
          margin-left: 12px;
        }
        .client-item {
          >label {
            width: 170px;
            font-size: 13px;
            text-align: right;
            padding-right: 12px;
          }
        }
        .operate-style {
          width: 140px;
          justify-content: space-evenly;
          font-weight: 800;
          cursor: pointer;
        }
      }
    }
  }
  .customer-info-style{
    list-style: none;
    >li{
      text-align: left;
    }
  }
}
</style>
